// src/services/reportsApiClient.js
import axios from "axios";
import { sessionAuthorization } from "./sessionAuthorization";

const baseURL = process.env.REACT_APP_REPORTS_API_URL;

export const reportsClient = axios.create({
  baseURL,
  headers: {
    "Content-Type": "application/json",
  },
});

reportsClient.interceptors.request.use(sessionAuthorization);

export default reportsClient;
